import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getHotelStatic } from 'src/api/hotelApi';
import { hotelAction } from 'src/redux/actions';
import { propsBasicLayoutType } from 'utils/proptypes';
import { useTranslation } from 'react-i18next';

const MapLayout = (props: propsBasicLayoutType) => {
   const dispatch = useDispatch();
   const [_t] = useTranslation();

   const { data } = useQuery({
      queryKey: ['getHotelStatic'],
      queryFn: getHotelStatic,
      retry: false,
      staleTime: Infinity,
   });

   useEffect(() => {
      if (data?.data) {
         dispatch(hotelAction.setHotelStatic(data?.data));
      }
   }, [data?.data]);

   return (
      <div className="flex-1 h-screen flex flex-col overflow-hidden">
         {/* `flex flex-col` is load-bearing: the shared #main-content wrapper (see src/layouts/index.tsx)
             is `flex-1 min-h-0`, which is inert inside a block parent. Without it #main-content falls back
             to content height — the map column grew to ~2000px inside a 700px box and only
             `overflow-hidden` above hid the spill, which is what the sidebar's hardcoded
             `h-[calc(100vh-70px)]` used to work around. */}
         <div className="flex-1 min-h-0 w-full relative flex flex-col">
            {props.children}
         </div>
      </div>);
};

export default MapLayout;
